$.fn.smoothScroll = function(selector) {
  return this.each(function() {
    $(this).on('click', function(event) {
      event.preventDefault();
      $('html, body').animate({scrollTop:$(this.hash).offset().top}, 500);
    });
  });
};


function highlightContact() {
  $('a[href="/#kontakt"]').smoothScroll();
}

function scrollBack() {
  $(document).ready(function() {
    var waypoint = 620;
    var $back = $('[data-scroll-back]');

    $back.on('click', function() {
      if ($back.hasClass('visible')) {
        $('html, body').animate({scrollTop: 0});
      }
    });

    var onScroll = function() {
      $back.toggleClass('visible', $(window).scrollTop() > waypoint);
    };

    $(window).on('scroll', onScroll);
    onScroll();
  });
}

function initialize() {
  highlightContact();
  scrollBack();
}

initialize();
